import { Header } from '@/components';
import { StyledLayout, StyledContent } from './styles';

type MainLayoutProps = {
  children: React.ReactNode;
};

const backgroundImgStyle = {
  backgroundImage: `url("/assets/images/backgroundImg.png")`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  overflow: 'hidden',
  heigth: '100vh',
  minHeight: '100vh',
};

export function MainLayout({children}: MainLayoutProps) { 
  return (
    <StyledLayout style={backgroundImgStyle}>  
      <Header />
      <StyledContent>{children}</StyledContent>
    </StyledLayout>
  );
}